export default __webpack_public_path__ + "static/media/Frame (1).c48a7a64.png";